@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container yes-no-container" [ngClass]="yesNoColumnClass">
    <div class="option-group-header">
        <span></span>
        @for (header of headerData; track trackHeader) {
            <span>{{ header }}</span>
        }
    </div>
    @for (group of optionGroups | slice: 0 : visibleOptionsLimit ?? showMoreData.initialVisibleCount; track trackGroup) {
        <div class="yes-no-option-row-container">
            <div class="attribute-key">
                @if (isShowHeadshotImage) {
                    <ms-participant-image
                        class="participant-logo"
                        [participantImage]="group[0].image"
                        [showLogoColor]="true"
                        [participantType]="participantType.Player"
                        [sportId]="event.sport.id" />
                }
                <span class="attribute-key-ellipsis">{{ group[0].player1 }}</span>
            </div>
            @for (header of headerData; track trackHeader) {
                <ng-container *ngTemplateOutlet="YesNoOptionGroup; context: { value: getOption(group, header) }"></ng-container>

                <ng-template #YesNoOptionGroup let-option="value">
                    @if (option) {
                        <ms-option
                            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
                            [option]="option"
                            [optionGroup]="optionGroup"
                            [event]="event"
                            [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
                            [sourceOfPick]="sourceOfPick"
                            [betDetails]="betDetails" />
                    } @else {
                        <div class="option option-pick empty-option">
                            <div class="offline option-indicator">
                                <div class="lock">
                                    <vn-icon
                                        class="option-group-lock-icon"
                                        [name]="isEpcotEnabled ? 'theme-locked' : 'theme-locked-i'"
                                        [size]="isEpcotEnabled ? '16' : '14'" />
                                </div>
                            </div>
                        </div>
                    }
                </ng-template>
            }
        </div>
    }
</div>
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}
